/**
 * Blog List - Infinite Scroll / Lazy Load
 * assets/blog-list-lazyload.js
 */

class BlogLazyLoad {
  constructor() {
    this.articlesGrid = document.querySelector('.blog-articles');
    this.paginationEl = document.querySelector('.pagination');

    if (!this.articlesGrid) return;

    this.totalPages = parseInt(this.articlesGrid.dataset.totalPages || '1', 10);
    this.currentPage = 1;
    this.isLoading = false;
    this.allLoaded = false;

    // Cache la pagination native
    if (this.paginationEl) {
      this.paginationEl.style.display = 'none';
    }

    // Ne rien faire s'il n'y a qu'une seule page
    if (this.totalPages <= 1) return;

    this.createLoader();
    this.initScrollListener();
  }

  createLoader() {
    this.loader = document.createElement('div');
    this.loader.className = 'blog-lazyload__loader';
    this.loader.style.cssText = 'display:none; justify-content:center; padding:3rem 0;';
    this.loader.innerHTML = '<span class="blog-lazyload__spinner"></span>';
    this.articlesGrid.insertAdjacentElement('afterend', this.loader);
  }

  initScrollListener() {
    const checkScroll = () => {
      if (this.isLoading || this.allLoaded) return;

      const scrollBottom = window.scrollY + window.innerHeight;
      const pageBottom = document.documentElement.scrollHeight - 400;

      if (scrollBottom >= pageBottom) {
        this.loadNextPage();
      }
    };

    // Throttle via requestAnimationFrame
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          checkScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Vérifie au chargement si la page est déjà trop courte
    setTimeout(checkScroll, 500);
  }

  buildUrl(page) {
    const params = new URLSearchParams(window.location.search);
    params.set('page', page);
    return `${window.location.pathname}?${params.toString()}`;
  }

  async loadNextPage() {
    if (this.isLoading || this.allLoaded) return;

    const nextPage = this.currentPage + 1;
    if (nextPage > this.totalPages) {
      this.allLoaded = true;
      this.loader.style.display = 'none';
      return;
    }

    this.isLoading = true;
    this.loader.style.display = 'flex';

    const url = this.buildUrl(nextPage);

    try {
      const response = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newArticles = doc.querySelectorAll('.blog-articles__article');

      if (newArticles.length === 0) {
        this.allLoaded = true;
        this.loader.style.display = 'none';
        return;
      }

      // Insère les nouveaux articles avec fade-in
      newArticles.forEach((article) => {
        article.style.opacity = '0';
        article.style.transition = 'opacity 0.4s ease';
        this.articlesGrid.appendChild(article);
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            article.style.opacity = '1';
          })
        );
      });

      this.currentPage = nextPage;

      // Met à jour l'URL sans rechargement
      const newParams = new URLSearchParams(window.location.search);
      newParams.set('page', nextPage);
      window.history.replaceState({}, '', `${window.location.pathname}?${newParams.toString()}`);

      // Vérifie si c'était la dernière page
      if (this.currentPage >= this.totalPages) {
        this.allLoaded = true;
        this.loader.style.display = 'none';
      }
    } catch (error) {
      console.error('[BlogLazyLoad] Erreur de chargement:', error);
    } finally {
      this.isLoading = false;
      if (!this.allLoaded) {
        this.loader.style.display = 'none';
      }
    }
  }
}

// Protection contre la double initialisation
if (!window.BlogLazyLoadInitialized) {
  window.BlogLazyLoadInitialized = true;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new BlogLazyLoad());
  } else {
    new BlogLazyLoad();
  }
}
